<div #chart id="{{divid}}" class="full-width full-height" [ngClass]="className !== '' ? className: ''"></div>
